import React, { useMemo } from 'react';

import { CertificatePreview } from './CertificatePreview';

// Shared components
import { PreviewButton } from '~/App/shared/components/Donation/components/Forms/components/CertificatePreviews/components/PreviewButton';
import { ICommerceVariant } from '~/types/ICommerceVariant';

type Props = {
  variant: ICommerceVariant;
  openModal: () => void;
};

export function CertificateSummary({ variant, openModal }: Props) {
  return useMemo(
    () => (
      <>
        <CertificatePreview
          certificate={{ ...variant.certificate, image: variant.primaryImage }}
        />
        <PreviewButton onClick={openModal}>
          Förhandsgranska gåvobevis
        </PreviewButton>
      </>
    ),
    [openModal, variant]
  );
}
